import { ICreateItensChecklistUseCase } from "../../../presentation/useCases/create/create_itens_checklist_use_case";
import { CreateItensChecklistResponseModels } from "../../models/items_checklist_model";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * CreateItensChecklistUseCase
 */

export class CreateItensChecklistUseCase implements ICreateItensChecklistUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async createItensChecklist(idChecklist: number, codigo: string, descricao: string): Promise<CreateItensChecklistResponseModels> {
    return await this.repository.createItensChecklist(idChecklist, codigo, descricao);
  }
}
